import moment from "moment";
import { configurations } from "../configurations";
import { formatMoney } from "../features/utils/formatMoney";

export const errorTitle = (code) => {
  switch (code) {
    case configurations.errors.accommodationSearch:
      return "Accommodation Search";
    case configurations.errors.accommodationAvailbility:
      return "Availability";
    case configurations.errors.accommodationPayment:
      return "Accommodation payment";
    case configurations.errors.accommodationCancellation:
      return "Accommodation cancellation";
    case 401:
      return "Unauthorized";
    case 403:
      return "Forbidden";
    case 404:
      return "Not Found";
    case 500:
      return "Internal Server Error";
    default:
      return "Error";
  }
};

export const errorDescription = (code, payload) => {
  switch (code) {
    case "start_date_end_date":
      return `Both start date **${moment(payload.start_date).format(
        "DD MMM YYYY"
      )}** and end date **${moment(payload.end_date).format(
        "DD MMM YYYY"
      )}** are past dates, please change them to present or future dates and try again.`;
    case "start_date":
      return `The selected start date **${moment(payload.start_date).format(
        "DD MMM YYYY"
      )}** is a past date, please change it to a present or a future date and try again.`;
    case "end_date":
      return `The selected end date **${moment(payload.end_date).format(
        "DD MMM YYYY"
      )}** is a past date, please change it to a present or a future date and try again.`;
    case "82":
      return `Your account balance is ${formatMoney(
        payload?.balance
      )}. top up your wallet or choose another payment method to continue this purchase.`;
    case configurations.errorCodes.accommodationNoAvailability:
      return `There are no available rooms for this accommodation and date, please selected another date or accommodation`;
    case "10":
      return `This accommodation is not cancellable this late.`;
    case "46":
      return `Oops! It seems the ticket you're trying to issue is not issuable. Please contact our support team for assistance.`;
    case "1011":
      return `Card Not Found! Verify the account details and ensure everything is in order and try again!`;
    case "42":
      return `We're experiencing an error from Paystack - our 3rd-party payment gateway`;
    case 401:
      return "Unauthorized description";
    case 403:
      return "Forbidden description";
    case 404:
      return "Not Found description";
    case 500:
      return "Internal Server Error description";
    default:
      return "Error description";
  }
};
